import React from "react";
import A from "components/layout/Link";
import Title from "components/layout/Title";
import logoImg from "assets/logo-outline.svg";

const Intro = () => {
    return (
        <>
            <Title
                bg={logoImg}
                bgSize="200%"
                bgRepeat="no-repeat"
                bgPos="center bottom"
            >
                Welcome
                <br />
                <b className="fifty">to</b>
                <i className="vgain">v</i>gain
            </Title>

            <h2 className="introtext">
                This site is my personal project to learn more about the
                nutrients in vegan food.
            </h2>

            <h3 className="introtext">
                My goal is to divide vegan food into macros to show the
                muscle-building potential it has.
            </h3>

            <h4 className="introtext">
                As you probably have seen, this page is divided into four pages,
                the three first pages are about macros (
                <A to="/protein" title="goto protein">
                    protein
                </A>
                ,{" "}
                <A to="/carbs" title="goto carbs">
                    carbs
                </A>
                . and{" "}
                <A to="/fats" title="goto fats">
                    fats
                </A>
                .) and the last one is about supplements{" "}
                <A to="/supps" title="goto supplements">
                    (supps)
                </A>
                .
            </h4>
        </>
    );
};

export default Intro;
